import { faker } from '@faker-js/faker';

export const signer = {
  key: faker.string.uuid(),
  name: faker.person.fullName(),
  documentation: '531.820.148-20',
  birthday: '2000-01-01',
  email: faker.internet.email(),
  phone_number: faker.internet.email(),
  federal_data_confirmed: false,
  has_documentation: true,
};

export const agreements = [
  {
    key: faker.string.uuid(),
    role: 'sign',
    signed: false,
    signer: {
      key: signer.key,
      email: signer.email,
      phone_number: signer.phone_number,
    },
  },
];
